import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import authContext from '../../context/authContext/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { editUserAction } from '../../redux/actions/userAction';
import RenderError from '../../utils/RenderError';
import { isValidEmail, isValidPhone } from '../../utils/utils';
import Loader from '../../utils/Loader';

const UserUpdateModal = ({ isOpen, toggle, userId, users, getUsers }) => {
  const { getConfig } = useContext(authContext)
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.users)

  const intialState = { nameError: '', emailError: '', answerError: '', addressError: '', phoneError: '' }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState({ ...intialState });
    toggle();
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  useEffect(() => {
    const user = (users || []).find((user) => user?._id === userId);
    setState({ user: JSON.parse(JSON.stringify(user || null)) })
  }, [userId]);

  const updateUserstate = (key, value) => {
    const { user } = state || {};
    user[key] = value;

    if (key === 'dematStatus' && value === 'approved') {
      user.dematApprovedAt = new Date().toISOString();
      user.dematStatusUpdated = true;
    }

    setState({ user })
  }

  const validateEmail = () => {
    const { email } = state.user;
    const isValid = isValidEmail(email);
    if (!isValid) {
      setState({ emailError: '*Please enter a valid email!' })
    }
  }

  const validateName = () => {
    const { name = '' } = state.user;

    if (!name.length) {
      setState({ nameError: '*Please enter a valid name!' })
    }
  }

  const validateAnswer = () => {
    const { answer = '' } = state.user;
    if (!answer.length) {
      setState({ answerError: '*Please enter a valid answer!' })
    }
  }

  const validatePhone = () => {
    const { phone = '' } = state.user;
    const isValid = isValidPhone(phone)
    if (!isValid) {
      setState({ phoneError: '*Provide valid indian numbers' })
    }
  }

  const checkError = () => {
    const errorKeys = ['nameError', 'emailError', 'answerError', 'addressError', 'phoneError'];
    const hasError = errorKeys.some((errorKey) => state[errorKey])
    return hasError
  }

  const handleUpdateUser = (e) => {
    e.preventDefault();
    const isError = checkError()
    if (isError) {
      return;
    }

    updateUser();
  };

  const updateUser = () => {
    const update = state.user;
    const config = getConfig();
    dispatch(editUserAction(update, config, getUsers, onHideModal))
  }

  const toDisplayFormat = (value) => {
    // YYYY-MM-DD → DD/MM/YYYY
    if (!value) return "";
    const [yyyy, mm, dd] = value.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const toInputFormat = (value) => {
    // DD/MM/YYYY → YYYY-MM-DD
    if (!value) return "";
    const [dd, mm, yyyy] = value.split("/");
    return `${yyyy}-${mm}-${dd}`;
  };

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Edit User</div>
          <div className='ml-3'>
            <Loader isLoading={loading || state.loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleUpdateUser} disabled={loading || state.loading}>
          <div className='row'>
            <div className='col-md-6'>
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  class="form-control"
                  min={0}
                  value={state.user?.name}
                  onChange={(e) => updateUserstate('name', e.target.value)}
                  onFocus={() => setState({ nameError: intialState.nameError })}
                  onBlur={validateName}
                  disabled={loading || state.loading}
                />
                <RenderError error={state?.nameError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  value={state.user?.email}
                  onChange={(e) => updateUserstate('email', e.target.value)}
                  onFocus={() => setState({ emailError: intialState.emailError })}
                  onBlur={validateEmail}
                  disabled={loading || state.loading}
                />
                <RenderError error={state?.emailError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group">
                <label for="exampleInputNumber1">Answer</label>
                <input
                  type="text"
                  class="form-control"
                  value={state.user?.answer}
                  onChange={(e) => updateUserstate('answer', e.target.value)}
                  onFocus={() => setState({ answerError: intialState.answerError })}
                  onBlur={validateAnswer}
                  disabled={loading || state.loading}
                />
                <RenderError error={state?.answerError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group">
                <label for="exampleInputNumber1">Gd Tokens</label>
                <input
                  type="number"
                  class="form-control"
                  id="exampleInputNumber1"
                  min={0}
                  value={state.user?.gdTokens}
                  onChange={(e) => updateUserstate('gdTokens', Number(e.target.value))}
                  disabled={loading || state.loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group">
                <label >Phone</label>
                <input
                  type="text"
                  class="form-control"
                  min={0}
                  value={state?.user?.phone}
                  onChange={(e) => updateUserstate('phone', e.target.value)}
                  onFocus={() => setState({ phoneError: intialState.phoneError })}
                  onBlur={validatePhone}
                  disabled={loading || state.loading}
                />
                <div>
                  <small className='form-text text-muted'>Pattern: +91XXXXXXXXXX</small>
                </div>
                <RenderError error={state.phoneError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">DOB*</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  class="form-control"
                  value={toInputFormat(state?.user?.dob)}
                  pattern="\d{2}/\d{2}/\d{4}"
                  onChange={(e) => updateUserstate('dob', toDisplayFormat(e.target.value))}
                  onFocus={() => setState({ dobError: '' })}
                  disabled={loading || state.loading}
                />
                <div className='form-text text-muted'>Format: DD/MM/YYYY</div>
              </div>
            </div>


            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Aadhar number</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="XXXXXXXXXXXX"
                  value={state?.user?.aadhar}
                  onChange={(e) => updateUserstate('aadhar', e.target.value)}
                  disabled={loading || state.loading}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Pan number</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="XXXXXXXXXX"
                  value={state?.user?.pan}
                  onChange={(e) => updateUserstate('pan', e.target.value)}
                  disabled={loading || state.loading}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Client Id</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="XXXXXXXXXX"
                  value={state?.user?.clientId}
                  onChange={(e) => updateUserstate('clientId', e.target.value)}
                  disabled={loading || state.loading}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Demat Status</label>
                <select
                  className="form-control"
                  value={state?.user?.dematStatus}
                  onChange={(e) => updateUserstate('dematStatus', e.target.value)}
                  disabled={loading || state.loading}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Refer Id</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="XXXXXXXXXX"
                  value={state?.user?.referId}
                  onChange={(e) => updateUserstate('referId', e.target.value)}
                  disabled={loading || state.loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label className='mb-1'>Nominee</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nominee Name"
                  value={state?.user?.nominee}
                  onChange={(e) => updateUserstate('nominee', e.target.value)}
                  disabled={loading || state.loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group">
                <label >Address</label>
                <input
                  type="text"
                  class="form-control"
                  min={0}
                  value={state?.user?.address}
                  onChange={(e) => updateUserstate('address', e.target.value)}
                  onFocus={() => setState({ addressError: intialState.addressError })}
                  disabled={loading || state.loading}
                />
                <RenderError error={state.addressError} />
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading || state.loading}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleUpdateUser} disabled={loading || state.loading}>
          Update User
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default UserUpdateModal